import { STATICS } from 'statics'
import './style.scss'

export function CarouselArrowBanner({
  className,
  onClick,
  disabled = false,
  isNext = false,
  icon = STATICS.ARROW_PREVIOUS,
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`carousel-arrow-banner ${className} ${isNext ? '-next' : '-prev'} ${
        disabled ? '-disabled' : ''
      }`}
    >
      <div className='icon'>{icon}</div>
    </button>
  )
}
